import React from "react";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";

type Option = {
  label: React.ReactNode;
  value: any;
  optionDisabled?: boolean;
};

type SelectProps = {
  label: string;
  id: string;
  name: string;
  minWidth?: number;
  maxWidth?: number;
  disabled?: boolean;
  value?: any;
  defaultValue?: any;
  onChange?: any;
  options: Option[];
};

const SelectComponent = ({
  label,
  id,
  name,
  disabled,
  value,
  defaultValue,
  onChange,
  minWidth,
  maxWidth,
  options,
}: SelectProps) => {
  return (
    <FormControl
      sx={{
        minWidth: { minWidth },
        maxWidth: { maxWidth },
        background: "white",
        width: "100%",
      }}
      size="small"
      disabled={disabled}
    >
      <InputLabel id={`${id}-label`}>{label}</InputLabel>
      <Select
        labelId={`${id}-label`}
        id={id}
        label={label}
        name={name}
        value={value}
        defaultValue={defaultValue}
        onChange={onChange}
        disabled={disabled}
      >
        {options &&
          options.map(({ value, label, optionDisabled }: Option) => (
            <MenuItem
              key={"SelectOption-" + value}
              value={value}
              disabled={optionDisabled}
            >
              {label}
            </MenuItem>
          ))}
      </Select>
    </FormControl>
  );
};

export default SelectComponent;
